import API from 'utils/API';
import http from 'utils/http';

class ModifyStore {
    verifyPwd = params => http.post(API.OAUTH.verifyPassword(), params);
    getVerifyOption = params => http.post(API.OAUTH.modify.verifyOptions(), params);
    verifyOtpCode = params => http.post(API.OAUTH.verifyOtp(), params);
    verifySetting = (type, params) => http.post(API.OAUTH.modify.verifySetting(type), params);
    verifyId = params => http.post(API.OAUTH.modify.verifyIdNo(), params);
    modifySetting = (type, params) => http.put(API.OAUTH.modify.modifySetting(type), params);
    updatePassword = params => http.put(API.OAUTH.updatePassword(), params);
}

export default new ModifyStore();
